/**
 * Exchange Desk internal navigation (the module's OWN menu — distinct from the
 * portal's top nav). Mirrors the shop's Python app: a Buy Gold POS plus an
 * Administration area. Admin sections are shown only on desktop, to privileged
 * users (device model: mobile = Buy AU only; desktop = Buy or Administration).
 */
export const EXCHANGE_DESK_SECTIONS = [
  {
    id: 'buy',
    label: 'Buy Gold',
    icon: 'Scale',
    admin: false,
    description: 'Weigh, price and record a gold or silver purchase',
  },
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'LayoutDashboard',
    admin: true,
    description: "Today's activity, payouts and live price status",
    planned: ['Today / week / month KPIs', 'Gold & silver price status + refresh', 'Quick totals'],
  },
  {
    id: 'transactions',
    label: 'Transactions',
    icon: 'Receipt',
    admin: true,
    description: 'Browse, view and edit past purchases',
    planned: ['Searchable transaction list', 'View / edit customer + envelope', 'Soft-delete (legal retention)'],
  },
  {
    id: 'reports',
    label: 'Reports',
    icon: 'BarChart3',
    admin: true,
    description: 'Daily reports and exports',
    planned: ['Daily report by date', 'CSV export', 'PDF export'],
  },
  {
    id: 'envelopes',
    label: 'Envelopes',
    icon: 'Package',
    admin: true,
    description: '30-day hold tracking for each purchase',
    planned: ['Hold countdown per envelope', 'Ready-to-use alerts', 'Sorted by hold date'],
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Settings',
    admin: true,
    description: 'Deságio rates, price lock, currency, price APIs',
    planned: ['Deságio: jewelry 30% / coin-bar 20%', 'Price lock minutes, currency', 'Price API sources & keys'],
  },
  {
    id: 'contract',
    label: 'Contract Template',
    icon: 'FileText',
    admin: true,
    description: 'Company info, terms and logo for the contract',
    planned: ['Company name / address / tax id', 'Terms & footer', 'Logo upload'],
  },
  {
    id: 'operators',
    label: 'Operators',
    icon: 'Users',
    admin: true,
    description: 'Staff PINs and access (also in Settings → Users)',
    planned: ['Add / rename operators', 'Set 4–8 digit PIN', 'Admin flag, enable / disable'],
  },
  {
    id: 'audit',
    label: 'Audit Log',
    icon: 'ScrollText',
    admin: true,
    description: 'Every action — who did what and when',
    planned: ['Transaction / settings / operator events', 'Operator + timestamp', 'Filter by action'],
  },
]
